export default Object.freeze({
    CATEGORIES: [
        {
            name: 'Annual Reports',
            label: 'Annual Reports',
            icon: 'book',
            colorClass: 'category-annual-reports-color'
        },
        {
            name: 'General Meetings',
            label: 'General Meetings',
            icon: 'calendar2',
            colorClass: 'category-general-meetings-color'
        },
        {
            name: 'IR Presentations',
            label: 'IR Presentations',
            icon: 'clipboard-data',
            colorClass: 'category-ir-presentations-color'
        },
        {
            name: 'Policies',
            label: 'Policies',
            icon: 'card-list',
            colorClass: 'category-policies-color'
        },
        {
            name: 'Quarterly Statements',
            label: 'Quarterly Statements',
            icon: 'blockquote-left',
            colorClass: 'category-quarterly-statements-color'
        },
        {
            name: 'Sustainability Reports',
            label: 'Sustainability Reports',
            icon: 'arrow-repeat',
            colorClass: 'category-sustainability-reports-color'
        },
        {
            name: 'Other',
            label: 'Other',
            icon: 'building',
            colorClass: 'category-other-color'
        },
    ],
});
